"use client"

import { useClientTranslations } from "@/hooks/useClientTranslations"
import { useIsCartageTeamMember } from "@/hooks/useIsCartageTeamMember"
import { useWilsonMode } from "@/components/chat/hooks/useWilsonMode"
import { useWindowManager } from "./useWindowManager"

interface DesktopShortcut {
    id: "meetWilson"
    iconSrc: string
    label: string
    ariaLabel: string
    onOpen: () => void
}

export function useDesktopShortcuts(): DesktopShortcut[] {
    const isCartageTeamMember = useIsCartageTeamMember()
    const { demoMode } = useWilsonMode()
    const { openWindow } = useWindowManager()
    const tSetup = useClientTranslations("desktop.setup")
    const tA11y = useClientTranslations("desktop.a11y")

    if (!isCartageTeamMember && !demoMode) return []

    return [
        {
            id: "meetWilson",
            iconSrc: "/setup/icons/document-architecture.svg",
            label: tSetup("sidebar.slideDeck"),
            ariaLabel: tA11y("openMeetWilson"),
            onOpen: () => openWindow("meetWilson", { source: "desktopIcon" }),
        },
    ]
}
